import type { RouteRecordRaw } from 'vue-router'
import { ROUTE_ROLES } from '@/utils/permissions'

const routes: RouteRecordRaw[] = [
  {
    path: '/listings/applications',
    name: 'ListingApplications',
    component: () => import('@/views/listings/index.vue'),
    meta: {
      title: '挂牌申请',
      permission: 'listings:manage',
      roles: ROUTE_ROLES.listingApplications
    }
  },
  {
    path: '/listings/detail/:id',
    name: 'ListingDetail',
    component: () => import('@/views/listings/detail.vue'),
    meta: {
      title: '挂牌详情',
      permission: 'listings:manage',
      roles: ROUTE_ROLES.listingApplications,
      hidden: true
    }
  },
  {
    path: '/listings/lifecycle',
    name: 'ListingLifecycle',
    component: () => import('@/views/listings/lifecycle.vue'),
    meta: {
      title: '生命周期运营',
      permission: 'listings:manage',
      roles: ROUTE_ROLES.listingLifecycle
    }
  },
  {
    path: '/listings/dual-control',
    name: 'ListingDualControlApprovals',
    component: () => import('@/views/listings/dualControl.vue'),
    meta: {
      title: '双人复核中心',
      permission: 'listings:manage',
      roles: ROUTE_ROLES.dualControlCenter
    }
  }
]

export default routes
